/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { channelDeliveryOutcomeDataChannelSchema } from './ChannelDeliveryOutcomeDataChannelSchema'
import { channelDeliveryOutcomeDataOutcomeSchema } from './ChannelDeliveryOutcomeDataOutcomeSchema'
import { channelDeliveryOutcomeDataReasonSchema } from './ChannelDeliveryOutcomeDataReasonSchema'

export const channelDeliveryOutcomeDataSchema = z.object({
	channel: channelDeliveryOutcomeDataChannelSchema,
	outcome: channelDeliveryOutcomeDataOutcomeSchema,
	reason: channelDeliveryOutcomeDataReasonSchema.nullable(),
})

export type ChannelDeliveryOutcomeDataSchema = z.infer<typeof channelDeliveryOutcomeDataSchema>
